export enum BoundarySource {
  CLIENT = 'client',
  SERVER = 'server',
}

export interface ParsedBoundaryError {
  message: string;
  stack?: string;
  source: BoundarySource;
  boundary?: string;
  digest?: string;
}

export interface ErrorBoundaryTags {
  source: BoundarySource;
  boundary?: string;
  digest?: string;
}

export interface ErrorBoundaryExtra {
  stack?: string;
  digest?: string;
  errorInfo?: unknown;
}

export interface ErrorBoundaryCaptureInfo {
  tags: ErrorBoundaryTags;
  extra: ErrorBoundaryExtra;
}
